export function formatDate(iso?: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
}

export function formatDateTime(iso?: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })
}

/** `manage_end_users` → "Manage end users". Display only; pages show the raw name too. */
export function permissionLabel(permission: string): string {
  const words = permission.split('_').join(' ')
  return words.charAt(0).toUpperCase() + words.slice(1)
}

/** A workspace member's display name: "First Last", else email, else the user id (D39 nulls). */
export function memberName(m: {
  user_id: string
  first_name?: string | null
  last_name?: string | null
  email?: string | null
}): string {
  return [m.first_name, m.last_name].filter(Boolean).join(' ') || m.email || m.user_id
}
